import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import {
  loadRequestForInformationAsync,
  selectRequestForInformation,
} from "../../../redux/slices/requestForInformation";
import RequestForInformationHeader from "./RequestForInformationHeader";
import RequestForInformationDetails from "./RequestForInformationDetails";
import Page500 from "../../../pages/auth/Page500";

const RequestForInformation = () => {
  const [loading, setLoading] = useState(false);
  const [loadingRfiId, setLoadingRfiId] = useState("");

  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const requestForInformationSelector = useAppSelector(
    selectRequestForInformation
  );

  const dispatch = useAppDispatch();

  let { profileNo, requestForInformationId } = useParams();
  if (!profileNo || !requestForInformationId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  const requestForInformation =
    requestForInformationSelector.requestForInformation;

  if (requestForInformationId !== loadingRfiId) {
    setLoadingRfiId(requestForInformationId);
    dispatch(loadRequestForInformationAsync(requestForInformationId));
    return <Loading />;
  }

  if (!requestForInformation) {
    return <Loading />;
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RequestForInformationHeader
            requestForInformation={requestForInformation}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RequestForInformationDetails
            requestForInformation={requestForInformation}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            requestForInformation={requestForInformation}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        requestForInformation={requestForInformation}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default RequestForInformation;
